import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import i18n from '../i18n';

interface Props {
  children: ReactNode;
}

function ErrorFallback() {
  return (
    <div className="h-screen w-screen bg-zinc-950 flex flex-col items-center justify-center gap-4 text-zinc-100">
      <span className="text-5xl">⚠️</span>
      <h1 className="text-xl font-semibold">{i18n.t('errors.error_occurred')}</h1>
      <p className="text-sm text-zinc-400">{i18n.t('errors.app_error')}</p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-4 py-2 rounded-lg bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-sm transition-colors"
      >
        {i18n.t('errors.reload_page')}
      </button>
    </div>
  );
}

export function ErrorBoundary({ children }: Props) {
  return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
}
